import React, { ComponentProps } from "react";

import * as Styles from "./Input.styles";

type Props = ComponentProps<typeof Styles.Input>;

export const Input = (props: Props) => {
  return <Styles.Input {...props} className="px-3.5 py-2" />;
};
